import { useContext } from "react";
import { ComponentDetailPageContext, PageNewState } from "./";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ComponentDetailPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
